import type { ReactElement } from 'react'

import { InvoicingSettingsSection } from '../../../enums/invoicingSettingsSection'
import { ComplianceSettingsForm } from '../../../modules/compliance'
import { EInvoicingSettingsForm } from '../../../modules/eInvoicing'
import { InvoiceSettingsForm } from '../../../modules/invoice'
import { LogoAndBrandingSettingsForm } from '../../../modules/logoAndBranding'
import { PaymentsAndRemindersSettingsForm } from '../../../modules/paymentsAndReminders'
import { PresetsSettingsForm } from '../../../modules/presets'
import { QuoteSettingsForm } from '../../../modules/quote'

interface InvoicingSettingsSectionContentProps {
  activeSection: InvoicingSettingsSection
}

const sectionContentBySection: Record<InvoicingSettingsSection, () => ReactElement> = {
  [InvoicingSettingsSection.Compliance]: ComplianceSettingsForm,
  [InvoicingSettingsSection.EInvoicing]: EInvoicingSettingsForm,
  [InvoicingSettingsSection.Invoice]: InvoiceSettingsForm,
  [InvoicingSettingsSection.LogoAndBranding]: LogoAndBrandingSettingsForm,
  [InvoicingSettingsSection.PaymentsAndReminders]: PaymentsAndRemindersSettingsForm,
  [InvoicingSettingsSection.Presets]: PresetsSettingsForm,
  [InvoicingSettingsSection.Quote]: QuoteSettingsForm,
}

export const InvoicingSettingsSectionContent = ({
  activeSection,
}: InvoicingSettingsSectionContentProps): ReactElement => {
  const ActiveSectionContent = sectionContentBySection[activeSection]

  return <ActiveSectionContent />
}
